<template>
<div class="borderb" v-for="item in data">
    <a :href="item.clickUrl" :data-scp="'ylike.'+ $index" :data-trace-id="item.traceId">
        <div class="padding30 flex-container vfull left bg-white">
            <div class="border">
                <img :src="item.imageUrl" width="140" height="140" onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'">
            </div>
            <div class="flex1 paddingl20 flex-container-col vfull left pos-r">  
                <div class="flex1">
                    <div class="fs-13 text-darker text-fixed2 lh-16" style="height:2.5em" v-text="item.title"></div>
                    <div class="fs-10 text-light text-fixed3 margint5" style="line-height:12px; height:3.5em" v-text="item.promotion"></div>
                    <div class="flex-container left margint10" style="padding:2px 0" v-show="item.countryImageUrl">
                        <img :src="item.countryImageUrl" width="12" height="12">
                        <span class="flex1 text-light fs-10 marginl10 text-limit1" v-text="item.countryName"></span>
                    </div>
                    <div class="margint10 text-limit1">
                        <span class="text-red fs-14" v-text="'¥'+ item.priceString"></span><del class="fs-10 text-light marginl10" v-text="'¥'+ item.originalPriceString" v-if="item.priceString !== item.originalPriceString"></del>
                    </div>
                </div>
                <div class="margint5 flex-container">
                    <div class="badge orange reverse pill small">
                        <object>
                            <a :href="item.brandClickUrl" class="text-limit1 text-orange text-white lh-16" style="height: 16px;max-width: 110px" v-text="item.brandName"></a>
                        </object>
                    </div>
                </div>
                <div class="fs-20 icon icon-fittingShow_share pos-a" style="bottom:0;right:0" @click.stop.prevent="share(item)" 
                        v-show="showShare"></div>
            </div>
        </div>
    </a>
</div>
</template>
<style lang="scss">
    .btnRight{
        padding:0 12px 0 7px;
        min-width: 70px;
        clip-path:polygon(0 0,100% 0,calc(100% - 7px) 8px, 100% 100%, 0 100%);
    }
    .counterStyle{
        background: #FFF4E5;
    }
    .counterStyle:after{
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 6px solid white;
        border-bottom: 8px solid transparent;
        top:0;
        right:0;
    }
    .margint5{
        margin-top:0.066666rem;
    }
</style>
<script>
import app from "app";
export default{
    props:{
        data:Array,
        showShare:{
            type: Boolean,
            default: false
        }
    },
    methods:{
        share:function(item){
            let shareInfo = {
                title: '【天狗网】'+item.title+' ，仅售'+item.priceString+'元',
                subTitle: item.promotion || '',
                friendTitle: '【天狗网】'+item.title+'，仅售'+item.priceString+'元！ ',
                imageUrl: 'https:'+item.imageUrl,
                url:'https:'+item.clickUrl,
                interStore: item.interStore
            };
            
            app.share( shareInfo );
        }
    }
}
</script>